import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { EditorEditContainer } from 'components/childRegister/Editor/EditorEditContainer';
import { useStyles } from 'components/shared/dialogs/ChildrenEditModal/ChildrenEditModal.styles';
import { useModalClosedContext } from 'context/ModalClosedContext';
import React from 'react';

interface EditChildrenModalProps {
  title: string;
  open: boolean;
  childrenId: string;
  onClose: (updated: boolean) => void;
  scrollTo?: { tab: string; elementId: string };
}

export const ChildrenEditModal = (props: EditChildrenModalProps) => {
  const classes = useStyles();
  const { notifyModalClosed } = useModalClosedContext();
  const handleClose = (updated: boolean) => {
    props.onClose(updated);
    notifyModalClosed();
  };

  return (
    <Dialog fullWidth maxWidth={'xl'} disableEscapeKeyDown open={props.open} PaperProps={{ className: 'vh-100' }}>
      <DialogTitle id="confirm-title">{props.title}</DialogTitle>
      <DialogContent className={classes.container}>
        {props.childrenId && (
          <EditorEditContainer
            id={props.childrenId}
            goBack={handleClose}
            showGuardiansHelp={true}
            scrollTo={props.scrollTo}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
